import * as React from 'react';

/**
 * @description HeartWithCheckmark icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { HeartWithCheckmark } from '@sravni/design-system-icons'
 *
 * <HeartWithCheckmark />
 * ```
 */
const HeartWithCheckmark = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "HeartWithCheckmark", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { clipRule: "evenodd", d: "M12 5.711C12.689 4.905 13.881 4 15.696 4 18.87 4 21 6.98 21 9.755 21 15.556 13.778 20 12 20c-1.778 0-9-4.444-9-10.245C3 6.98 5.13 4 8.304 4c1.815 0 3.007.905 3.696 1.711Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m14.89 10.056-3.612 3.611L9.111 11.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { HeartWithCheckmark };
//# sourceMappingURL=HeartWithCheckmark.js.map
